import { takeLatest, call, select, takeEvery, put } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { cloneDeep, get } from 'lodash';
import queryString from 'query-string';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';

const SEARCH_JOBS = 'jobs/SEARCH_JOBS';
const CHANGE_FILTER = 'jobs/CHANGE_FILTER';
const START_SEARCH = 'jobs/START_SEARCH';
const RESET_FILTERS = 'jobs/RESET_FILTERS';

const jobsReducer = (state = [], action) => {
    switch (action.type) {
        case SEARCH_JOBS:
        case actionKey.init(SEARCH_JOBS): {
            if (!action.filters || !action.filters.offset) {
                return [];
            }
            return state;
        }
        case actionKey.success(SEARCH_JOBS):
            if (action.filters.offset) {
                return [
                    ...state,
                    ...get(action, 'payload.jobs', []),
                ];
            }
            return get(action, 'payload.jobs', []);
        default:
            return state;
    }
};

const loadingReducer = (state = false, action) => {
    switch (action.type) {
        case actionKey.init(SEARCH_JOBS):
            return true;
        case actionKey.failure(SEARCH_JOBS):
        case actionKey.success(SEARCH_JOBS):
            return false;
        default:
            return state;
    }
};

const errorReducer = (state = null, action) => {
    switch (action.type) {
        case SEARCH_JOBS:
        case actionKey.init(SEARCH_JOBS):
        case actionKey.success(SEARCH_JOBS):
            return null;
        case actionKey.failure(SEARCH_JOBS): {
            if (action.status === 400) {
                return action.error;
            }
            return state;
        }
        default:
            return state;
    }
};

const serverErrorReducer = (state = null, action) => {
    switch (action.type) {
        case SEARCH_JOBS:
        case actionKey.init(SEARCH_JOBS):
        case actionKey.success(SEARCH_JOBS):
            return null;
        case actionKey.failure(SEARCH_JOBS): {
            if (action.status !== 400) {
                return action.error;
            }
            return state;
        }
        default:
            return state;
    }
};

export const filtersReducer = (state = {
    zip: '',
    query: '',
    radius: 25,
    jobType: '',
    source: 'indeed',
    offset: 0,
    strength: [],
    filters: 0,
    retry: 0,
    sort: 'relevance',
}, action) => {
    switch (action.type) {
        case CHANGE_FILTER: {
            const newState = {
                ...state,
                ...action.payload,
            };
            newState.offset = action.payload.offset || 0;
            if (action.payload.offset) {
                newState.retry += 1;
            } else {
                newState.retry = 0;
            }
            return newState;
        }
        case actionKey.success(SEARCH_JOBS):
            return {
                ...state,
                offset: action.payload.count,
            };
        case RESET_FILTERS: {
            return {
                ...state,
                radius: 25,
                strength: [],
                jobType: '',
                ...(action.payload || {}),
            };
        }
        default:
            return state;
    }
};

export const countReducer = (state = 0, action) => {
    switch (action.type) {
        case actionKey.success(SEARCH_JOBS):
            return action.payload.count;
        default:
            return state;
    }
};

const initStateReducer = (state = true, action) => {
    switch (action.type) {
        case actionKey.init(SEARCH_JOBS):
            return false;
        default:
            return state;
    }
};

const haveMoreReducer = (state = false, action) => {
    switch (action.type) {
        case actionKey.success(SEARCH_JOBS):
            return action.payload.haveMore;
        default:
            return state;
    }
};

const validLocation = (state = true, action) => {
    switch (action.type) {
        case CHANGE_FILTER: {
            if (action.payload.zip) {
                return true;
            }
            return state;
        }
        case SEARCH_JOBS:
            return true;
        case actionKey.success(SEARCH_JOBS):
            return action.payload.validLocation;
        default:
            return state;
    }
};

export default combineReducers({
    loading: loadingReducer,
    list: jobsReducer,
    initState: initStateReducer,
    error: errorReducer,
    serverError: serverErrorReducer,
    filters: filtersReducer,
    count: countReducer,
    haveMore: haveMoreReducer,
    validLocation,
});

export const changeFilterAction = payload => ({
    type: CHANGE_FILTER,
    payload,
});

export const searchJobsAction = () => ({
    type: SEARCH_JOBS,
});

export const resetFiltersAction = payload => ({
    type: RESET_FILTERS,
    payload,
});

export const startSearchAction = filters => ({
    type: START_SEARCH,
    payload: { filters },
});

export function* rootSaga() {
    yield [
        takeEvery([SEARCH_JOBS, CHANGE_FILTER, RESET_FILTERS], checkSearch),
        takeLatest(START_SEARCH, startSearch),
    ];
}

export function* checkSearch({ type, payload = {} }) {
    const state = yield select();
    const { filters, initState } = state.jobs;
    if (
        type === CHANGE_FILTER
        && !('searchInit' in payload)
        && ('query' in payload || 'zip' in payload || initState)
    ) {
        return;
    }
    if (!filters.query.replace(/\s/g, '')) {
        return;
    }
    yield put(startSearchAction(filters));
}

export function* startSearch({ payload: { filters } }) {
    const newFilters = cloneDeep(filters);
    if ('searchInit' in newFilters)
        delete newFilters.searchInit;
    const params = queryString.stringify(newFilters);

    yield call(request, {
        type: SEARCH_JOBS,
        url: `/api/jobs/search?${params}`,
        filters: newFilters,
    });
}



// WEBPACK FOOTER //
// ./src/client/redux/jobs.js